/* The site-wide dot-wave background: one setting per page.

     full   the dots at their normal (very dim) strength
     faint  half strength, where photos must stay the focus
     off    no dots, and the image is never requested

   Read by SiteBackground.jsx on every navigation. A path that matches
   nothing below is OFF, so a page added later never gets the background by
   accident; payment, cart, account and admin pages are listed anyway so the
   intent is explicit and tested (src/config/siteBackground.test.js).

   Matching is by path prefix: "/category" covers "/category/electronics".
   A prefix matches the path itself or a path continuing with "/", never a
   longer word ("/sell" does not match "/seller"). The FIRST match wins, so
   specific entries come before broader ones. An entry may also name a query
   that switches it off (the inbox's Orders folder lives on the inbox's own
   path, behind ?folder=orders). */

export const SITE_BACKGROUND_MODES = ["full", "faint", "off"];

export const SITE_BACKGROUND_ROUTES = [
  // Never: money, personal data, staff tools. Listed first so no broader
  // entry below can ever switch them on.
  ["/cart", "off"],
  ["/checkout", "off"],
  ["/orders", "off"],
  ["/live", "off"],              // live shopping takes an M-Pesa payment on the page
  ["/account/orders", "off"],    // redirects into the inbox's Orders folder
  ["/inbox", "off"],             // redirects to /account/inbox
  ["/wishes", "off"],            // an account page (header menu), not a public listing
  ["/admin", "off"],
  ["/sell/portal", "off"],       // seller dashboard
  ["/sell/apply", "off"],        // seller application forms
  ["/newsletter", "off"],
  // The all-categories index already has its own full-page photo
  // background (back.JPG); dots under it would be hidden or fight it.
  ["/categories", "off"],

  // My Account (Overview, Profile, Privacy & Data are tabs of /account),
  // the inbox and deliveries (owner's amendment, 2026-10-10). Forms,
  // messages and delivery cards keep solid panels; the pattern shows round
  // them. The inbox's Orders folder stays off, like every orders page.
  ["/account/inbox", "full", { offWhenQuery: ["folder", "orders"] }],
  ["/account", "full", { exact: true }],
  ["/deliveries", "full"],

  // Photos are the point here.
  ["/product", "faint"],

  // Browsing, information and sign-in.
  ["/", "full", { exact: true }],
  ["/category", "full"],
  ["/search", "full"],
  ["/shop", "full"],             // a seller's public shop (2026-10-17)
  ["/collections", "full"],
  ["/rails", "full"],
  ["/new-arrivals", "full"],
  ["/suits", "full"],
  ["/shirts", "full"],
  ["/shoes", "full"],
  ["/sell", "full", { exact: true }],   // the public "sell on Emporia" letter
  ["/about", "full"],
  ["/returns", "full"],
  ["/shipping", "full"],
  ["/terms", "full"],
  ["/privacy", "full"],
  ["/login", "full"],
  ["/register", "full"],
  ["/verify", "full"],           // the second step of signing up
];

function matches(pathname, prefix, exact) {
  if (exact) return pathname === prefix || pathname === `${prefix}/`;
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function siteBackgroundFor(pathname, search = "") {
  const path = pathname || "/";
  const query = new URLSearchParams(search || "");
  for (const [prefix, mode, opts = {}] of SITE_BACKGROUND_ROUTES) {
    if (!matches(path, prefix, opts.exact)) continue;
    if (opts.offWhenQuery && query.get(opts.offWhenQuery[0]) === opts.offWhenQuery[1]) return "off";
    return mode;
  }
  return "off";
}
